<script lang="ts">
  import { _ } from "svelte-i18n";
  import { type Product, mapToProductCard } from "$lib/utils/dynamicBundle";
  import ProductCard from "$lib/components/Cards/ProductCard/ProductCard.svelte";

  export let product: Product;
  export let products: Product[] = [];
  let productIndex: number;

  $: (productIndex = products.findIndex(p => p.id === product.id)),
    product,
    products;

  const handleSecondaryProductsColourOption = (e: any) => {
    const rootProductSelected = products.find((prod: Product) => {
      let match =
        prod.id.replace("gid://shopify/Product/", "") ===
        e.detail.pid.replace("gid://shopify/Product/", "");
      if (!match) {
        match = !!prod.colourOptionProducts.find((prod: Product) => {
          return (
            prod.id.replace("gid://shopify/Product/", "") ===
            e.detail.pid.replace("gid://shopify/Product/", "")
          );
        });
      }
      return match;
    });

    let productSelected: Product;
    if (
      !rootProductSelected.options
        .find((opt: any) => opt.name === "colour")
        .values.includes(e.detail.identifier)
    ) {
      const actualSelectedProduct =
        rootProductSelected.colourOptionProducts.find((prod: Product) => {
          return prod.options
            .find((opt: any) => opt.name === "colour")
            .values.includes(e.detail.identifier);
        });
      productSelected = {
        ...actualSelectedProduct,
        colourOptionProducts: [
          ...rootProductSelected.colourOptionProducts.filter(
            (prod: Product) => {
              return !prod.options
                .find((opt: any) => opt.name === "colour")
                .values.includes(e.detail.identifier);
            },
          ),
          { ...rootProductSelected, colourOptionProducts: null },
        ],
      };
    }
    const castProducts = products.map((prod: Product) => {
      if (
        productSelected &&
        prod.id.replace("gid://shopify/Product/", "") ===
          rootProductSelected.id.replace("gid://shopify/Product/", "")
      ) {
        return productSelected;
      }
      return prod;
    });

    if (productSelected) {
      product = productSelected;
      products = castProducts;
    }
  };
</script>

<style lang="scss">
  .cart-bundle-card-container {
    width: 100%;
  }
  :global(
      div.dynamic-bundle > div > div > div > div.product-card--img-wrapper > div
    ) {
    max-height: 300px !important;
  }
  :global(div.dynamic-bundle > div > div > div > div.product-card--info) {
    background-color: transparent !important;
  }
  :global(
      div.dynamic-bundle
        > div
        > div
        > div
        > div.product-card--info
        > div
        > div.gradient-right
    ) {
    background-image: linear-gradient(
      to right,
      rgba(255, 255, 255, 0),
      #f7f7f7
    ) !important;
  }
  :global(
      div.dynamic-bundle
        > div
        > div
        > div
        > div.product-card--info
        > div
        > div.gradient-left
    ) {
    background-image: linear-gradient(
      to left,
      rgba(255, 255, 255, 0),
      #f7f7f7
    ) !important;
  }
</style>

<div class="cart-bundle-card-container">
  <ProductCard
    {...mapToProductCard(product, productIndex, products)}
    on:selectColourOption={handleSecondaryProductsColourOption}
    smallThumb={false}
  />
</div>
